import { render, staticRenderFns } from "./expense_items.vue?vue&type=template&id=07e1e2d4&"
import script from "./expense_items.vue?vue&type=script&lang=js&"
export * from "./expense_items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports